import React from 'react';
import { FileText, Clock } from 'lucide-react';
import siteConfig from '../config/contentConfig';

const Whitepaper = () => {
  return (
    <section
      id="whitepaper"
      data-testid="whitepaper-section"
      className="section-container bg-[#0C0E12]"
    >
      <div className="text-center space-y-4 mb-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#FFD600]/20 mb-4">
          <FileText size={32} className="text-[#FFD600]" />
        </div>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
          <span className="text-[#32B44A]">{siteConfig.token.symbol}</span>{' '}
          Whitepaper
        </h2>
        <div className="w-24 h-1 bg-[#FFD600] mx-auto rounded-full" />
        <p className="text-slate-300 max-w-3xl mx-auto text-lg">
          Discover the vision, technology, and roadmap behind the most community-powered memecoin on Supra.
        </p>
      </div>

      {/* Coming Soon Card */}
      <div className="max-w-4xl mx-auto">
        <div className="glass rounded-3xl p-12 sm:p-16 text-center border border-yellow-500/30 card-hover">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-[#FFD600] to-[#32B44A] mb-8 animate-pulse-glow">
            <Clock size={48} className="text-black" />
          </div>
          
          <h3 className="text-3xl sm:text-4xl font-black mb-4">
            Coming Soon
          </h3>
          
          <p className="text-lg sm:text-xl text-slate-300 max-w-2xl mx-auto mb-8">
            We're working hard on preparing the complete $NANA whitepaper with detailed information about tokenomics, technology, and our long-term vision.
          </p>
          
          <div className="inline-flex items-center space-x-2 text-[#FFD600] font-semibold">
            <span className="inline-block w-2 h-2 rounded-full bg-[#FFD600] animate-pulse"></span>
            <span>Stay tuned for updates!</span>
          </div>
        </div>
      </div>

      {/* Quick Info Cards */}
      <div className="max-w-6xl mx-auto mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="glass rounded-xl p-6 border border-yellow-500/10 text-center">
          <h4 className="font-bold mb-2">Total Supply</h4>
          <p className="text-2xl font-black text-[#FFD600]">1B $NANA</p>
        </div>
        
        <div className="glass rounded-xl p-6 border border-yellow-500/10 text-center">
          <h4 className="font-bold mb-2">Blockchain</h4>
          <p className="text-2xl font-black text-[#32B44A]">Supra</p>
        </div>
        
        <div className="glass rounded-xl p-6 border border-yellow-500/10 text-center">
          <h4 className="font-bold mb-2">Community</h4>
          <p className="text-2xl font-black text-[#FFD600]">Driven</p>
        </div>
      </div>
    </section>
  );
};

export default Whitepaper;
